import React, {useEffect, useState} from 'react';
import {Card, CardContent, Typography, Box} from '@mui/material';
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import "./CaseHistory.css";
import axios from "axios";
import {useLocation} from "react-router-dom";
import {MdArrowForward} from "react-icons/md";
import ExportToExcel from "./ExportToExcel";
import {AiOutlineHistory} from "react-icons/ai";

function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function CaseHistory({caseFiles, geoIds, deletedFiles, users, caseData}) {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const query = useQuery();
    const caseId = query.get('id');
    const [caseLogs, setCaseLogs] = useState([]);
    const reversedCaseLogs = [...caseLogs].reverse();
    const [municipalities, setMunicipalities] = useState([]);
    const [regions, setRegions] = useState([]);
    const [councils, setCouncils] = useState([]);
    const [populatedAreas, setPopulatedAreas] = useState([]);

    const fileName = `განაცხადის_ისტორია_${caseData.caseNumber}`;

    const rolesInGeorgian = {
        'HEADOFAGENCY': "სააგენტოს უფროსი",
        'DEPUTYHEADOFAGENCY': "უფროსის მოადგილე",
        'HEADOFDEPARTMENT': "სამმართველოს უფროსი",
        'EXPERT': "სპეციალისტი"
    };

    const findUserRoleById = (userId) => {
        const user = users.find(user => user.id === userId)
        if (user){
            return " ("  + rolesInGeorgian[`${user.roleName}`.toUpperCase()] + ")"
        }
        else
            return " (მომხამრებელი)"
    }


    const caseRoles = {
        1: "შემსრულებელი",
        2: "ვიზატორი",
        3: "მეორადი შემსრულებელი",
        4: "ვიზატორი",
        5: "მეორადი შემსრულებელი",
    };

    const findRegionById = (id) => {
        const region = regions.find(r => r.id === parseInt(id, 10));
        return region ? region.itemName : "";
    }


    const findMunicipalityById = (id) => {
        const municipality = municipalities.find(m => m.id === parseInt(id, 10));
        return municipality ? municipality.itemName : "";
    }

    const findCouncilsById = (id) => {
        const council = councils.find(c => c.id === parseInt(id, 10));
        return council ? council.itemName : "";
    }

    const findPopulatedAreaById = (id) => {
        const area = populatedAreas.find(a => a.id === parseInt(id, 10));
        return area ? area.itemName : "";
    }


    useEffect(() => {
        const fetchGeographicData = async () => {
            try {
                const [regionRes, municipalityRes, councilRes, populatedAreaRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`),
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.municipalityId}`),
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.councilId}`),
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.cityId}`)
                ]);

                setRegions(regionRes.data.success ? regionRes.data.data.resultlist : []);
                setMunicipalities(municipalityRes.data.success ? municipalityRes.data.data.resultlist : []);
                setCouncils(councilRes.data.success ? councilRes.data.data.resultlist : []);
                setPopulatedAreas(populatedAreaRes.data.success ? populatedAreaRes.data.data.resultlist : []);
            } catch (error) {
            }
        };

        void fetchGeographicData();
    }, [geoIds]);

    useEffect(() => {
        async function GetAllCaseNotifications() {
            try {
                const response = await axios.get(`${baseURL}/GetAllCasenotificationByCaseID?CaseId=${caseId}`);
                const logs = response.data.data;
                if (logs !== null){
                    setCaseLogs(logs);
                }

            } catch (error) {
            }
        }

        void GetAllCaseNotifications();
    }, [caseId, baseURL]);

    const findCaseFileById = (fileID) => {
        const file = caseFiles.find(file => file.id === fileID);
        if (!file) {
            const deletedFile = deletedFiles.find(file => file.id === fileID)
            return deletedFile ? deletedFile : "";
        }
        return file ? file : "";
    };
    const findCaseFilesByIds = (fileIDs) => {
        return fileIDs.map(fileID => {
            const file = caseFiles.find(file => file.id === parseInt(fileID, 10));
            if (!file) {
                const deletedFile = deletedFiles.find(file => file.id === parseInt(fileID, 10));
                return deletedFile ? `Deleted File: ${deletedFile.name}` : "";
            }
            return file ? `დახარვეზებული დოკუმენტები: ${file.name}` : "";
        }).join(', ');
    };
    const findCaseFilesByIdsPostpone = (fileIDs) => {
        return fileIDs.map(fileID => {
            const file = caseFiles.find(file => file.id === parseInt(fileID, 10));
            if (!file) {
                const deletedFile = deletedFiles.find(file => file.id === parseInt(fileID, 10));
                return deletedFile ? `Deleted File: ${deletedFile.name}` : "";
            }
            return file ? `დოკუმენტი: ${file.name}` : "";
        }).join(', ');
    };


    return (
        <div>

            {populatedAreas.length === 0 || caseLogs.length === 0 ?

                (
                    <div className="nothing-found-message">
                        <AiOutlineHistory style={{fontSize: 80, color: '#1A9AEE'}} className={"pulse-element"}/>
                        <h1>გთხოვთ დაელოდოთ...</h1>
                        <p>ისტორია იტვირთება!</p>
                    </div>

                ) : (
                    <>
                        <ExportToExcel data={reversedCaseLogs} caseFiles={caseFiles} deletedFiles={deletedFiles} fileName={fileName} />
                    <Box style={{padding: '20px'}}>
                        {reversedCaseLogs.map((log) => (
                            <Card className="card-enter" variant="outlined" key={log.id} style={{marginBottom: '20px'}}>
                                <CardContent>
                                    {
                                        log.action === CaseNotificationEnum.editedField.id ||
                                        log.action === CaseNotificationEnum.createdFile.id ||
                                        log.action === CaseNotificationEnum.removeUser.id ||
                                        log.action === CaseNotificationEnum.addUser.id ||
                                        log.action === CaseNotificationEnum.mergedCase.id ||
                                        log.action === CaseNotificationEnum.movedCaseToObjectRegistery.id ||
                                        log.action === CaseNotificationEnum.editedFile.id ||
                                        log.action === CaseNotificationEnum.newCaseExpert.id ||
                                        log.action === CaseNotificationEnum.visagedFile.id ||
                                        log.action === CaseNotificationEnum.headOfAgencyDeclinedCase.id ||
                                        log.action === CaseNotificationEnum.headApprovedRewriteRequest.id ||
                                        log.action === CaseNotificationEnum.deletedFile.id ||
                                        log.action === CaseNotificationEnum.headDeniedRewriteRequest.id ||
                                        log.action === CaseNotificationEnum.signedTheDocument.id ||
                                        log.action === CaseNotificationEnum.removeCaseFromRegistery.id ||
                                        log.action === CaseNotificationEnum.visagedInternalFile.id
                                            ? (
                                                <Typography variant="h6" component="h2">
                                                    {log.lastStepUserFullName} {findUserRoleById(log.lastStepUserId)}
                                                </Typography>
                                            ) : (
                                                <Typography variant="h6" component="h2">
                                                    {log.lastStepUserFullName}{findUserRoleById(log.lastStepUserId)}
                                                    <MdArrowForward style={{verticalAlign: 'middle', margin: '0 4px'}}/>
                                                    {log.nextStepUserFullName}{findUserRoleById(log.nextStepUserId)}
                                                    {log.сaseRole && (
                                                       " " + "(" + caseRoles[log.сaseRole] + ")"
                                                    )}

                                                </Typography>

                                            )}
                                    {findCaseFileById(log.documentId) && (
                                        <Typography variant="body2" component="p">
                                            დოკუმენტი:{' '}
                                            <a href={findCaseFileById(log.documentId).path} target="_blank"
                                               rel="noopener noreferrer" className="document-url">
                                                {findCaseFileById(log.documentId).name ? findCaseFileById(log.documentId).name : "დოკუმენტი წაშლილია"}
                                            </a>
                                        </Typography>
                                    )}

                                    <Typography color="textSecondary">
                                        ქმედება: {CaseNotificationEnum[Object.keys(CaseNotificationEnum).find(key => CaseNotificationEnum[key].id === log.action)].title}
                                    </Typography>
                                    {log.action === CaseNotificationEnum.removeUser.id && (
                                        <Typography color="textSecondary">
                                            წაიშალა: {log.newUserInfo.fullName + " - " + (rolesInGeorgian[log.newUserInfo.roleName])}
                                        </Typography>
                                    )}
                                    {log.declinationReason && (
                                        <Typography color="textSecondary">
                                            მიზეზი: {log.declinationReason}
                                        </Typography>
                                    )}
                                    {log.declinationDays && (
                                        <Typography color="textSecondary">
                                            დღეების რაოდეობა: {log.declinationDays}
                                        </Typography>
                                    )}
                                    {log.caseFileIds && log.caseFileIds.length > 0 && log.action !== CaseNotificationEnum.postponeCaseDeclinationDaysRequest.id &&(
                                        <Typography variant="body2" component="p">
                                            {findCaseFilesByIds(log.caseFileIds)}
                                        </Typography>
                                    )}
                                    {log.caseFileIds && log.caseFileIds.length > 0 && log.action === CaseNotificationEnum.postponeCaseDeclinationDaysRequest.id &&(
                                        <Typography variant="body2" component="p">
                                            {findCaseFilesByIdsPostpone(log.caseFileIds)}
                                        </Typography>
                                    )}
                                    {log.action === CaseNotificationEnum.addUser.id && (
                                        <>
                                            <Typography color="textSecondary">
                                                დაემატა: {log.newUserInfo.fullName + " - " + (rolesInGeorgian[log.newUserInfo.roleName])}
                                            </Typography>
                                            <Typography color="textSecondary">
                                                წაიშალა: {log.oldUserInfo.fullName + " - " + (rolesInGeorgian[log.newUserInfo.roleName])}
                                            </Typography>
                                        </>
                                    )}


                                    <Typography variant="body2" component="p">
                                        თარიღი: {formatDate(log.createAt)}
                                    </Typography>
                                    {log.key && log.key.map((keyItem, idx) => {
                                        let oldValue = log.oldValue?.[idx] || "";
                                        let newValue = log.newValue?.[idx] || "";

                                        if (keyItem === "რეგიონი") {
                                            oldValue = findRegionById(oldValue);
                                            newValue = newValue.split(', ').map(findRegionById).join(', ');
                                        } else if (keyItem === "მუნიციპალიტეტი") {
                                            oldValue = findMunicipalityById(oldValue);
                                            newValue = newValue.split(', ').map(findMunicipalityById).join(', ');
                                        } else if (keyItem === "საკრებულო") {
                                            oldValue = findCouncilsById(oldValue);
                                            newValue = newValue.split(', ').map(findCouncilsById).join(', ');
                                        } else if (keyItem === "დასახლებული პუნქტი") {
                                            oldValue = findPopulatedAreaById(oldValue);
                                            newValue = newValue.split(', ').map(findPopulatedAreaById).join(', ');
                                        }

                                        return (
                                            <div className="record-container" key={idx}>
                                                <Typography variant="body2" className="record-title">
                                                    ველი: {keyItem}
                                                </Typography>
                                                <Typography variant="body2" className="record-value">
                                                    ძველი მნიშვნელობა: {oldValue}
                                                </Typography>
                                                <Typography variant="body2" className="record-value">
                                                    ახალი მნიშვნელობა: {newValue}
                                                </Typography>
                                            </div>
                                        );
                                    })}
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                    </>
                )}
        </div>
    );
}

export default CaseHistory;